export default function Divisor(){

    return(
        <div className="modal-form-divisor"></div>
    )

}